import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const TRSClusterNameField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.name && touched.name}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Cluster Name
                </FormLabel>
                <Field
                    name="name"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Enter cluster name"
                            label="Cluster Name *"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter a unique name for this cluster"
                        ariaLabel="cluster-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError error={errors?.name} touched={touched?.name} />
        </FormControl>
    );
};

export default TRSClusterNameField;
